var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.16671 0.5C3.80665 0.5 0.990302 5.10559 0.939364 5.18945C0.8708 5.27778 0.833448 5.38722 0.833374 5.5C0.833461 5.59675 0.860991 5.6914 0.912627 5.77246L0.914537 5.77539C0.922943 5.79313 3.28702 10.5 8.16671 10.5C13.0257 10.5 15.3863 5.83937 15.4151 5.78223C15.417 5.77899 15.4189 5.77574 15.4208 5.77246C15.4724 5.6914 15.5 5.59675 15.5 5.5C15.5 5.38767 15.463 5.27862 15.395 5.19043L15.3941 5.18945C15.3431 5.10559 12.5268 0.5 8.16671 0.5ZM8.16671 2C10.0568 2 11.5889 3.567 11.5889 5.5C11.5889 7.433 10.0568 9 8.16671 9C6.27666 9 4.74449 7.433 4.74449 5.5C4.74449 3.567 6.27666 2 8.16671 2ZM8.16671 4C7.77772 4 7.40467 4.15804 7.12962 4.43934C6.85456 4.72064 6.70004 5.10218 6.70004 5.5C6.70004 5.89782 6.85456 6.27936 7.12962 6.56066C7.40467 6.84197 7.77772 7 8.16671 7C8.55569 7 8.92874 6.84197 9.2038 6.56066C9.47885 6.27936 9.63337 5.89782 9.63337 5.5C9.63337 5.10218 9.47885 4.72064 9.2038 4.43934C8.92874 4.15804 8.55569 4 8.16671 4Z",
    fill: "#827C8E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow);
export default __webpack_public_path__ + "static/media/show.20dc1236.svg";
export { ForwardRef as ReactComponent };